import {Component} from '@angular/core'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {MatFormField, MatLabel} from '@angular/material/form-field'
import {MatOption, MatSelect} from '@angular/material/select'
import {countryCodes} from '../../types'
import {InputBaseComponent} from '../0-base/input-base.component'

@Component({
  selector: 'spb-mobile-area-code',
  imports: [
    MatFormField,
    MatLabel,
    ReactiveFormsModule,
    FormsModule,
    MatSelect,
    MatOption
  ],
  templateUrl: './mobile-area-code.component.html',
  styleUrl: './mobile-area-code.component.scss',
  providers: [{provide: InputBaseComponent, useExisting: MobileAreaCodeComponent}]
})
export class MobileAreaCodeComponent extends InputBaseComponent<string> {
  public countryCodes = countryCodes
  protected override prop = 'areaCode'
}
